import { render, staticRenderFns } from "./Recruiting.vue?vue&type=template&id=2c9bb178&scoped=true"
import script from "./Recruiting.vue?vue&type=script&lang=js"
export * from "./Recruiting.vue?vue&type=script&lang=js"
import style0 from "./Recruiting.vue?vue&type=style&index=0&id=2c9bb178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bb178",
  null
  
)

export default component.exports